import React from "react";
import { Typography, Container, withStyles } from "@material-ui/core";

const styles = theme => ({
  title: {
    fontWeight: "bold",
    color: theme.palette.primary.dark
  },
  section: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(6)
  },
  sectionHead: {
    color: theme.palette.primary.dark
  }
});

class About extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <Container>
        <section className={classes.section}>
          <Typography variant="h4" className={classes.title}>
            About Us
          </Typography>
          {/* <br /> */}
          <Typography variant="body1">
            This is the Official Website for the Society of Petroleum Engineers
            Student Chapter at The British University in Egypt.
          </Typography>
        </section>
        <section className={classes.section}>
          <Typography variant="h4" className={classes.sectionHead}>
            Our Vision
          </Typography>
          <Typography variant="body1">
            <ul>
              <li>
                To build a role model committee for all SPE R&amp;D committees
                in the middle East and worldwide
              </li>
            </ul>
          </Typography>
        </section>
        <section className={classes.section}>
          <Typography variant="h4" className={classes.sectionHead}>
            Our Mission
          </Typography>
          <Typography variant="body1">
            <ul>
              <li>Build a creative, inspired and motivated team</li>
              <li>Enhance the committee researches and reports</li>
              <li>
                Communicate and build partnerships with SPE clubs and other
                Petroleum clubs
              </li>
              <li>
                Enhancing the BUE Petroleum Engineers reputation all over the
                companies
              </li>
              <li>
                Providing more than +100 training opportunities per year
                cooperating with PR committee
              </li>
              <li>Alignment the Academic studies and working field</li>
              <li>Build an IT committee within the R&amp;D committee</li>
            </ul>
          </Typography>
        </section>
        <section className={classes.section}>
          <Typography variant="h4" className={classes.sectionHead}>
            Awards
          </Typography>
          <Typography variant="body1">
            <ul>
              <li>
                Best Student Chapter Of The Month Worldwide (September 2011)
              </li>
              <li>Golden Standard Award (2012)</li>
              <li>Outstanding Student Chapter (2012)</li>
              <li>SPE Section Service Award – Egypt Section - (2012)</li>
              <li>Golden Standard Award (2013)</li>
              <li>Golden Standard Award (2014)</li>
              <li>Outstanding Student Chapter (2014)</li>
              <li>Golden Standard Award (2015)</li>
              <li>Outstanding Student Chapter (2015)</li>
              <li>Golden Standard Award (2016)</li>
              <li>Outstanding Student Chapter (2016)</li>
              <li>Outstanding Student Chapter (2017)</li>
              <li> Outstanding Student Chapter (2018)</li>
            </ul>
          </Typography>
        </section>
      </Container>
    );
  }
}

export default withStyles(styles)(About);
